import React from "react";
import { Route, Switch } from "react-router-dom";

import AdminUsers from "./user-list";
import UserDetails from "./user-details";

const adminRouter = () => (
  <Switch>
    <Route path="/admin/user/:id" component={UserDetails} />
    <Route path="/admin/user" component={AdminUsers} />
  </Switch>
);

export default adminRouter;
